import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {

  1: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P12-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page12/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page12/2.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P12-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page12/E2/Key/answerKey.png',
    titleImage: '',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page12/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/0.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/01.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/3.jpg', input: 1 },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/5.jpg', input: 1,isCorrect: true },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/7.jpg', input: 1,  },
      ],
      [
        // Column 3
        { url: 'img/FriendsPlus/Page12/E2/8.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/10.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page12/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/12.jpg', input: 3, isCorrect: true },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/14.jpg', input: 2,  },
        { url: 'img/FriendsPlus/Page12/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/16.jpg', input: 3 },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/18.jpg', input: 2 ,isCorrect: true},
        { url: 'img/FriendsPlus/Page12/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page12/E2/20.jpg', input: 3 },
      ],
      [
        { url: 'img/FriendsPlus/Page12/E2/21.jpg' },
      ],
    ],
  },

}

export default json;